import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './initialClinicalFinding.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';


export class InitialClinicalFindingDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.initialClinicalFinding.isNullMessageHolder === false ?
      <div className="row item-row"
        data-qa={'initialClinicalFinding_' + this.props.initialClinicalFinding.clinicalFindingType}
      >
        <div className="col-md-4 primary-data">
          {
            this.props.initialClinicalFinding.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.initialClinicalFinding.clinicalFindingType}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.clinicalFindingDate} />}
                value={this.props.initialClinicalFinding.clinicalFindingDate}
                language={this.props.language} isDate
                isActive={this.configurationActive('ClinicalFindingDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.diseaseSite} />}
                value={this.props.initialClinicalFinding.diseaseSite} language={this.props.language}
                isActive={this.configurationActive('DiseaseSite')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.clinicalFindings} />}
                value={this.props.initialClinicalFinding.clinicalFindings} language={this.props.language}
                isActive={this.configurationActive('ClinicalFindings')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.initialClinicalFinding.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.initialClinicalFinding.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.initialClinicalFinding.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.initialClinicalFinding.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.initialClinicalFinding.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="initialClinicalFinding_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.initialClinicalFinding.nullMessage}
        </div>
      </div>
    );
  }
}

InitialClinicalFindingDetail.propTypes = {
  initialClinicalFinding: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
